import React, { useState } from 'react';
import NavBar from '../navbar/navbar';
import Footer from '../navbar/footer';
import InsightsActions from './insights';
import BusinessNarratives from './narratives';
import TextArea from '../../components/textArea';
import Logo from './img/bot.png';
import { BsArrowRightCircleFill } from 'react-icons/bs';
import { PiLightbulbFilament } from 'react-icons/pi';
import data from './data.json';
import config from '../../configs/config';
import './css/style.scss';

const HomePage = (props) => {
  const [query, setQuery] = useState('');
  const shuffled = data.suggested_insights.sort(function () {
    return 0.5 - Math.random();
  });
  const [questions, setQuestions] = useState(shuffled.slice(0, 3));

  const handleChange = ({ currentTarget: input }) => {
    setQuery(input.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      submitQuery();
    }
  };

  const submitQuery = (q = '') => {
    const userquery = q.length !== 0 ? q : query;
    if (userquery.length !== 0) {
      window.location =
        (config.prefix ? '/' + config.prefix_name : '') + '/chat?query=' + userquery;
    }
  };

  //Component 1
  const SearchBox = (
    <div className='place-container mb-3'>
      <div className='ask-question mb-4'>
        <img src={Logo} alt='AI' />
        <h5 className='m-0'>Ask a Question</h5>
      </div>
      <div className='ask-search'>
        <TextArea
          name='username'
          placeholder='Start exploring with your questions or use suggested insights'
          icon_left_show={false}
          icon={<BsArrowRightCircleFill />}
          show_icon_toggle={false}
          iconposition='right'
          iconclass='send'
          iconclick={() => submitQuery(query)}
          customclass='mb-2'
          value={query || ''}
          handleChange={handleChange}
          handleKeyDown={handleKeyDown}
        />
      </div>
    </div>
  );

  //Component 2
  const SuggestedInsights = (
    <div className='suggested-insights mb-3 place-container'>
      <div className='heading'>
        <PiLightbulbFilament /> Suggested Insights
      </div>
      <div className='insights'>
        {questions.map((x, i) => {
          return (
            <div className='queries' key={i} onClick={() => submitQuery(x)}>
              {x}
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <div id='home-page'>
      <NavBar />
      <div className='flex-fill d-flex justify-content-center overflow-auto row m-0'>
        <div className='content reduced-row'>
          <div className='row m-0'>
            <div className='col-xs-12 col-md-9 col-lg-9'>
              {SearchBox}
              <BusinessNarratives user={props.user} />
              {SuggestedInsights}
            </div>
            <div className='col-xs-12 col-md-3 col-lg-3'>
              <InsightsActions user={props.user} />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default HomePage;
